import React from 'react';
import { Helmet } from 'react-helmet';
import styled from 'styled-components';
import ContentWrapper from '../styles/ContentWrapper';

const Privacy = () => {
    const StyledThing = styled.article`

    `;

    return (
        <React.Fragment>
            <Helmet>
                <meta name='robots' content='noindex, nofollow' />
            </Helmet>
            <article role='article' about='/legal/privacy' typeof='schema:WebPage'>
                <span
                    property='schema:name'
                    content='Privacy'
                    className='stolo-hidden'
                />
                <ContentWrapper>
                    <div property='schema:text'><h1>Privacy Policy</h1>
                        <h2>1) Introduction and contact details of the controller</h2>
                        <p><b>1.1</b>&nbsp;We are pleased that you are visiting our website
                            and thank you for your interest. Below we inform you about how
                            we handle your personal data when you use our website. Personal
                            data here means all data that can be used to identify you
                            personally.</p>
                        <p><b>1.2</b>&nbsp;The controller responsible for data processing
                            on this website within the meaning of the General Data
                            Protection Regulation (DSGVO/GDPR) is Becker &amp; Karsten UG
                            (haftungsbeschr&auml;nkt), Sandhauser Str. 107, 13505 Berlin,
                            Germany, Tel.: +49 30 609851960, e-mail:
                            wir@beckerundkarsten.de. The controller responsible for the
                            processing of personal data is the natural or legal person who
                            alone or jointly with others determines the purposes and means
                            of the processing of personal data.</p>
                        <h2>2) Data collection when visiting our website</h2>
                        <p><b>2.1</b>&nbsp;When you use our website for purely
                            informational purposes, that is, if you do not register or
                            otherwise transmit information to us, we collect only such data
                            as your browser transmits to our server (so-called
                            &bdquo;server log files&#8220;). When you access our website, we
                            collect the following data, which is technically necessary for
                            us to display the website to you:
                        </p>
                        <ul>
                            <li>The website you visited on our site</li>
                            <li>Date and time at the moment of access</li>
                            <li>Amount of data sent in bytes</li>
                            <li>Source/referrer from which you reached the page
                            </li>
                            <li>Browser used</li>
                            <li>Operating system used</li>
                            <li>IP address used (where applicable: in anonymized form)</li>
                        </ul>
                        <p>The processing is carried out pursuant to Art. 6(1)(f) DSGVO
                            (GDPR) on the basis of our legitimate interest in improving the
                            stability and functionality of our website. The data is not
                            passed on or otherwise used. However, we reserve the right to
                            review the server log files subsequently should there be
                            concrete indications of unlawful use.</p>
                        <p><b>2.2</b>&nbsp;For security reasons and to protect the
                            transmission of personal data and other confidential content
                            (e.g. orders or enquiries sent to us), this website uses SSL or
                            TLS encryption. You can recognize an encrypted connection by
                            the character string &bdquo;https://&#8220; and the lock symbol
                            in your browser's address bar.</p>
                        <h2>3) Hosting &amp; Content Delivery Network</h2>
                        <p><b>3.1</b>&nbsp;Amazon Web Services</p>
                        <p>For the hosting of our website and the presentation of its
                            content, we use the system of the following provider:
                            AWS EMEA SARL, 38 avenue John F. Kennedy, L-1855 Luxembourg</p>
                        <p>Data may also be transmitted to: Amazon Web
                            Services, Inc., 410 Terry Avenue North, Seattle, WA 98109,
                            USA</p>
                        <p>All data collected on our website is processed on the
                            provider's servers. We have concluded a data processing
                            agreement with the provider that ensures the protection of our
                            site visitors' data and prohibits unauthorized disclosure to
                            third parties.</p>
                        <p>For data transfers to the USA, the provider has joined the
                            EU-US Data Privacy Framework, which, on the basis of an
                            adequacy decision of the European Commission, ensures
                            compliance with the European level of data protection.</p>
                        <p><b>3.2</b>&nbsp;Cloudflare</p>
                        <p>For the hosting of our website and the presentation of its
                            content, we use the system of the following provider:
                            Cloudflare Inc., 101 Townsend St. San Francisco, CA 94107,
                            USA</p>
                        <p>All data collected on our website is processed on the
                            provider's servers. We have concluded a data processing
                            agreement with the provider that ensures the protection of our
                            site visitors' data and prohibits unauthorized disclosure to
                            third parties.</p>
                        <p>For data transfers to the USA, the provider has joined the
                            EU-US Data Privacy Framework, which, on the basis of an
                            adequacy decision of the European Commission, ensures
                            compliance with the European level of data protection.</p>
                        <p><b>3.3</b>&nbsp;Shopify</p>
                        <p>For the hosting of our website and the presentation of its
                            content, we use the system of the following provider:
                            Shopify International Limited, Victoria Buildings, 2nd floor,
                            1-2 Haddington Road, Dublin 4, D04 XN32, Ireland
                            (&bdquo;Shopify&#8220;).</p>
                        <p>Data is also transferred to: Shopify Inc., 150 Elgin
                            St, Ottawa, ON K2P 1L4, Canada.</p>
                        <p>All data collected on our website is processed on the
                            provider's servers. We have concluded a data processing
                            agreement with the provider that ensures the protection of our
                            site visitors' data and prohibits unauthorized disclosure to
                            third parties.</p>
                        <p>For data transfers to Canada, an adequate level of data
                            protection is ensured by an adequacy decision of the European
                            Commission.</p>
                        <p><b>3.4</b>&nbsp;AWS-CloudFront</p>
                        <p>We use a content delivery network of the following
                            provider: AWS EMEA SARL, 38 avenue John F. Kennedy, L-1855
                            Luxembourg</p>
                        <p>This service enables us to deliver large media files such as
                            graphics, page content or scripts more quickly via a network
                            of regionally distributed servers. The processing is carried
                            out to safeguard our legitimate interest in improving the
                            stability and functionality of our website pursuant to Art.
                            6(1)(f) DSGVO (GDPR).</p>
                        <p>We have concluded a data processing agreement with the provider
                            that ensures the protection of our site visitors' data and
                            prohibits unauthorized disclosure to third parties.</p>
                        <p>Data may also be transmitted to: Amazon Web
                            Services, Inc., 410 Terry Avenue North, Seattle, WA 98109,
                            USA</p>
                        <p>For data transfers to the USA, the provider has joined the
                            EU-US Data Privacy Framework, which, on the basis of an
                            adequacy decision of the European Commission, ensures
                            compliance with the European level of data protection.</p>
                        <p><b>3.5</b>&nbsp;Cloudflare</p>
                        <p>We use a content delivery network of the following
                            provider: Cloudflare Inc., 101 Townsend St. San Francisco, CA
                            94107, USA</p>
                        <p>This service enables us to deliver large media files such as
                            graphics, page content or scripts more quickly via a network
                            of regionally distributed servers. The processing is carried
                            out to safeguard our legitimate interest in improving the
                            stability and functionality of our website pursuant to Art.
                            6(1)(f) DSGVO (GDPR). We have concluded a data processing
                            agreement with the provider that ensures the protection of our
                            site visitors' data and prohibits unauthorized disclosure to
                            third parties.</p>
                        <p>For data transfers to the USA, the provider has joined the
                            EU-US Data Privacy Framework, which, on the basis of an
                            adequacy decision of the European Commission, ensures
                            compliance with the European level of data protection.</p>
                        <p><b>3.6</b>&nbsp;Host Europe</p>
                        <p>We use a content delivery network of the following
                            provider: Host Europe GmbH, c/o WeWork, Friesenplatz 4, 50672
                            K&ouml;ln, Germany</p>
                        <p>This service enables us to deliver large media files such as
                            graphics, page content or scripts more quickly via a network
                            of regionally distributed servers. The processing is carried
                            out to safeguard our legitimate interest in improving the
                            stability and functionality of our website pursuant to Art.
                            6(1)(f) DSGVO (GDPR). We have concluded a data processing
                            agreement with the provider that ensures the protection of our
                            site visitors' data and prohibits unauthorized disclosure to
                            third parties.</p>
                        <p><b>3.7</b>&nbsp;Shopify</p>
                        <p>We use a content delivery network of the following
                            provider: Shopify International Limited, Victoria Buildings,
                            2nd floor, 1-2 Haddington Road, Dublin 4, D04 XN32, Ireland
                            (&bdquo;Shopify&#8220;)</p>
                        <p>Data may also be transferred to:</p>
                        <ul>
                            <li>Shopify Inc., 150 Elgin St, Ottawa, ON K2P 1L4, Canada
                            </li>
                            <li>Cloudflare Inc., 101 Townsend St. San Francisco, CA 94107,
                                USA
                            </li>
                        </ul>
                        <p>This service enables us to deliver large media files such as
                            graphics, page content or scripts more quickly via a network
                            of regionally distributed servers. The processing is carried
                            out to safeguard our legitimate interest in improving the
                            stability and functionality of our website pursuant to Art.
                            6(1)(f) DSGVO (GDPR). We have concluded a data processing
                            agreement with the provider that ensures the protection of our
                            site visitors' data and prohibits unauthorized disclosure to
                            third parties.</p>
                        <p>For data transfers to Canada, an adequate level of data
                            protection is ensured by an adequacy decision of the European
                            Commission.</p>
                        <p>For data transfers to the USA, the data recipient has joined
                            the EU-US Data Privacy Framework, which, on the basis of an
                            adequacy decision of the European Commission, ensures
                            compliance with the European level of data protection.</p>
                        <h2>4) Cookies</h2>
                        <p>In order to make visiting our website attractive and to enable
                            the use of certain functions, we use cookies, that is, small
                            text files that are stored on your device. Some of these
                            cookies are automatically deleted again after you close your
                            browser (so-called &bdquo;session cookies&#8220;), while others
                            remain on your device for longer and allow page settings to be
                            saved (so-called &bdquo;persistent cookies&#8220;). In the
                            latter case, you can find the storage period in the overview of
                            the cookie settings of your web browser.</p>
                        <p>Insofar as personal data is also processed by individual
                            cookies we use, the processing is carried out pursuant to Art.
                            6(1)(b) DSGVO (GDPR) either for the performance of the
                            contract, pursuant to Art. 6(1)(a) DSGVO (GDPR) in the case of
                            consent given, or pursuant to Art. 6(1)(f) DSGVO (GDPR) to
                            safeguard our legitimate interests in the best possible
                            functionality of the website as well as a customer-friendly and
                            effective design of the site visit.</p>
                        <p>You can set your browser so that you are informed about the
                            setting of cookies and can decide individually about their
                            acceptance, or you can exclude the acceptance of cookies for
                            certain cases or in general.</p>
                        <p>Please note that if cookies are not accepted, the functionality
                            of our website may be limited.</p>
                        <h2>5) Contacting us</h2>
                        <p><b>5.1</b>&nbsp;WhatsApp Business</p>
                        <p>We offer you the option of contacting us via the messaging
                            service WhatsApp provided by WhatsApp Ireland Limited, 4
                            Grand Canal Square, Grand Canal Harbour, Dublin 2, Ireland.
                            For this purpose, we use the so-called
                            &bdquo;Business version&#8220; of WhatsApp.</p>
                        <p>If you contact us by WhatsApp in connection with a specific
                            transaction (for example an order you have placed), we store
                            and use the mobile phone number you use on WhatsApp as well as
                            &ndash; if provided &ndash; your first and last name pursuant
                            to Art. 6(1)(b) DSGVO (GDPR) in order to process and respond to
                            your request. On the same legal basis, we may, where
                            applicable, ask you via WhatsApp to provide further data (order
                            number, customer number, address or e-mail address) in order to
                            be able to assign your enquiry to a particular case.</p>
                        <p>If you use our WhatsApp contact for general enquiries (for
                            example about our range of services, availability or our online
                            presence), we store and use the mobile phone number you use on
                            WhatsApp as well as &ndash; if provided &ndash; your first and
                            last name pursuant to Art. 6(1)(f) DSGVO (GDPR) on the basis of
                            our legitimate interest in providing the requested information
                            efficiently and promptly.</p>
                        <p>Your data is always used only to respond to your request via
                            WhatsApp. It is not passed on to third parties.</p>
                        <p>Please note that WhatsApp Business gains access to the address
                            book of the mobile device we use for this purpose and
                            automatically transfers phone numbers stored in the address
                            book to a server of the parent company Meta Platforms Inc. in
                            the USA. To operate our WhatsApp Business account, we use a
                            mobile device in whose address book we store exclusively the
                            WhatsApp contact details of those users who have also contacted
                            us via WhatsApp.</p>
                        <p>This ensures that every person whose WhatsApp contact details
                            are stored in our address book has already, when first using
                            the app on their device, consented by accepting the WhatsApp
                            terms of use to the transmission of their WhatsApp phone number
                            from the address books of their chat contacts pursuant to Art.
                            6(1)(a) DSGVO (GDPR). A transmission of data of those users who
                            do not use WhatsApp and/or have not contacted us via WhatsApp
                            is therefore excluded.</p>
                        <p>For the purpose and scope of the data collection and the further
                            processing and use of the data by WhatsApp, as well as your
                            related rights and the settings options available to protect
                            your privacy, please refer to the privacy notices of WhatsApp: <a
                                href="https://www.whatsapp.com/legal/?eea=1#privacy-policy"
                                target="_blank">https://www.whatsapp.com
                                <wbr/>
                                /legal
                                <wbr/>
                                /?eea=1#privacy-policy</a></p>
                        <p>In the course of the processing described above, data transfers
                            to servers of Meta Platforms Inc. in the USA may occur.</p>
                        <p>For data transfers to the USA, the provider has joined the
                            EU-US Data Privacy Framework, which, on the basis of an
                            adequacy decision of the European Commission, ensures
                            compliance with the European level of data protection.</p>
                        <p><b>5.2</b>&nbsp;When you contact us (e.g. via the contact form
                            or e-mail), personal data is processed &ndash; exclusively for
                            the purpose of processing and responding to your request and
                            only to the extent necessary for this &ndash;.</p>
                        <p>The legal basis for processing this data is our legitimate
                            interest in responding to your request pursuant to Art. 6(1)(f)
                            DSGVO (GDPR). If your contact is aimed at concluding a contract,
                            the additional legal basis for the processing is Art. 6(1)(b)
                            DSGVO (GDPR). Your data is deleted when it can be inferred from
                            the circumstances that the matter in question has been
                            conclusively clarified, provided that no statutory retention
                            obligations prevent this.</p>
                        <h2>6) Comment function</h2>
                        <p>In the context of the comment function on this website, in
                            addition to your comment, information about the time the comment
                            was created and the commenter name you have chosen are stored
                            and published on this website. Furthermore, your IP address is
                            logged and stored. This storage of the IP address is carried
                            out for security reasons and in case you violate the rights of
                            third parties through a comment you post or post unlawful
                            content. We need your e-mail address in order to contact you
                            should a third party object to your published content as
                            unlawful.</p>
                        <p>The legal bases for storing your data are Art. 6(1)(b) and (f)
                            DSGVO (GDPR). We reserve the right to delete comments if they
                            are objected to as unlawful by third parties.</p>
                        <p>As a user, you can subscribe to follow-up comments. You will
                            receive a confirmation e-mail for this purpose so that it can
                            be ensured that you are the owner of the e-mail address
                            provided (double opt-in procedure). The legal basis for data
                            processing in the case of subscribing to comments is Art.
                            6(1)(a) DSGVO (GDPR). You can cancel ongoing comment
                            subscriptions at any time with effect for the future; for
                            further information on how to unsubscribe, please refer to the
                            confirmation e-mail.</p>
                        <h2>7) Data processing when opening a customer
                            account</h2>
                        <p>Pursuant to Art. 6(1)(b) DSGVO (GDPR), personal data continues
                            to be collected and processed to the extent necessary in each
                            case when you provide it to us when opening a customer account.
                            You can find out which data is required for opening an account
                            from the input form of the relevant form on our website.</p>
                        <p>Your customer account can be deleted at any time and this can be
                            done by sending a message to the above address of the
                            controller. After your customer account has been deleted, your
                            data will be deleted, provided that all contracts concluded
                            through it have been fully processed, no statutory retention
                            periods prevent this, and we have no remaining legitimate
                            interest in continued storage.</p>
                        <h2>8) Use of customer data for direct advertising</h2>
                        <p><b>8.1</b>&nbsp;Subscription to our e-mail newsletter</p>
                        <p>If you subscribe to our e-mail newsletter, we will regularly
                            send you information about our offers. The only mandatory
                            information for sending the newsletter is your e-mail address.
                            Providing further data is voluntary and is used to be able to
                            address you personally. For sending the newsletter, we use the
                            so-called double opt-in procedure, which ensures that you only
                            receive the newsletter once you have expressly confirmed your
                            consent to receiving the newsletter by clicking a verification
                            link sent to the e-mail address provided.</p>
                        <p>By activating the confirmation link, you give us your consent to
                            the use of your personal data pursuant to Art. 6(1)(a) DSGVO
                            (GDPR). In doing so, we store the IP address assigned by your
                            internet service provider (ISP) as well as the date and time of
                            the registration, in order to be able to trace any possible
                            misuse of your e-mail address at a later point in time. The data
                            collected by us when you subscribe to the newsletter is used
                            strictly for the stated purpose.</p>
                        <p>You can unsubscribe from the newsletter at any time via the link
                            provided for this purpose in the newsletter or by a
                            corresponding message to the controller named at the beginning.
                            After you have unsubscribed, your e-mail address will be deleted
                            immediately from our newsletter distribution list, unless you
                            have expressly consented to further use of your data or we
                            reserve the right to use the data beyond this in a way that is
                            legally permitted and about which we inform you in this
                            statement.</p>
                        <p><b>8.2</b>&nbsp;MailChimp</p>
                        <p>Our e-mail newsletters are sent via the following provider: The
                            Rocket Science Group, LLC d/b/a MailChimp, 675 Ponce de Leon
                            Ave NE, Suite 5000, Atlanta, GA 30308, USA.</p>
                        <p>On the basis of our legitimate interest in effective and
                            user-friendly newsletter marketing, we pass on the data you
                            provided when subscribing to the newsletter to this provider
                            pursuant to Art. 6(1)(f) DSGVO (GDPR) so that it handles the
                            sending of the newsletter on our behalf.</p>
                        <p>Subject to your express consent pursuant to Art. 6(1)(a) DSGVO
                            (GDPR), the provider also carries out a statistical evaluation
                            of the success of newsletter campaigns by means of web beacons
                            or tracking pixels in the e-mails sent, which can measure
                            opening rates and specific interactions with the content of the
                            newsletter. In doing so, device information (e.g. time of
                            access, IP address, browser type and operating system) is also
                            collected and evaluated, but not combined with other data
                            sets.</p>
                        <p>You can revoke your consent to newsletter tracking at any time
                            with effect for the future.</p>
                        <p>We have concluded a data processing agreement with the provider
                            that protects the data of our site visitors and prohibits
                            disclosure to third parties.</p>
                        <p>For data transfers to the USA, the provider has joined the
                            EU-US Data Privacy Framework, which, on the basis of an
                            adequacy decision of the European Commission, ensures
                            compliance with the European level of data protection.</p>
                        <h2>9) Data processing for order fulfilment</h2>
                        <p><b>9.1</b>&nbsp;Transmission of image files for order
                            fulfilment by e-mail</p>
                        <p>On our website we offer you the option of commissioning the
                            personalization of products by transmitting image files by
                            e-mail. The submitted image motif is then used as a template
                            for the personalization of the selected product.</p>
                        <p>Via the e-mail address provided on the website, you can transmit
                            one or more image files from the storage of the device you use
                            to us. We then collect, store and use the files transmitted in
                            this way exclusively for the production of the personalized
                            product in accordance with the respective service description
                            on our website. Insofar as the transmitted image files are
                            passed on to special service providers for the production and
                            fulfilment of the order, you will be explicitly informed about
                            this in the following paragraphs. No disclosure beyond this
                            takes place. Insofar as the transmitted files or the digital
                            motifs contain personal data (in particular images of
                            identifiable persons), all the processing operations just named
                            are carried out exclusively for the purpose of processing your
                            online order pursuant to Art. 6(1)(b) DSGVO (GDPR).</p>
                        <p>After the order has been finally processed, the transmitted
                            image files are automatically and completely deleted.</p>
                        <p><b>9.2</b>&nbsp;Transmission of image files for order
                            fulfilment via upload function</p>
                        <p>On our website we offer you the option of commissioning the
                            personalization of products by transmitting image files via an
                            upload function. The submitted image motif is then used as a
                            template for the personalization of the selected product.</p>
                        <p>Via the upload form on the website, you can transmit one or more
                            image files from the storage of the device you use directly to
                            us by automated, encrypted data transmission. We then collect,
                            store and use the transmitted files exclusively for the
                            production of the personalized product in accordance with the
                            respective service description on our website. Insofar as the
                            transmitted image files are passed on to special service
                            providers for the production and fulfilment of the order, you
                            will be explicitly informed about this in the following
                            paragraphs. No disclosure beyond this takes place. Insofar as
                            the transmitted files or the digital motifs contain personal
                            data (in particular images of identifiable persons), all the
                            processing operations just named are carried out exclusively
                            for the purpose of processing your online order pursuant to
                            Art. 6(1)(b) DSGVO (GDPR).</p>
                        <p>After the order has been finally processed, the transmitted
                            image files are automatically and completely deleted.</p>
                        <p><b>9.3</b>&nbsp;Insofar as necessary for the performance of the
                            contract for delivery and payment purposes, the personal data
                            collected by us is passed on pursuant to Art. 6(1)(b) DSGVO
                            (GDPR) to the commissioned transport company and the
                            commissioned credit institution.</p>
                        <p>Insofar as we owe you updates for goods with digital elements or
                            for digital products on the basis of a corresponding contract,
                            we process the contact data you provided when ordering (name,
                            address, e-mail address) in order to inform you personally,
                            within the scope of our statutory information obligations
                            pursuant to Art. 6(1)(c) DSGVO (GDPR), by a suitable means of
                            communication (such as by post or e-mail) about upcoming
                            updates within the period provided for by law. Your contact
                            data is used here strictly for the purpose of notifications
                            about updates owed by us and is processed by us for this purpose
                            only to the extent necessary for the respective information.</p>
                        <p>To process your order, we also work with the following service
                            provider(s), who support us wholly or partly in carrying out
                            concluded contracts. Certain personal data is transmitted to
                            these service providers in accordance with the following
                            information.</p>
                        <p><b>9.4</b>&nbsp;Billbee</p>
                        <p>For order fulfilment we use the following provider: Billbee
                            GmbH, Arolser Str. 10, 34477 Twistetal</p>
                        <p>Name, address and, where applicable, further personal data is
                            passed on to the provider pursuant to Art. 6(1)(b) DSGVO (GDPR)
                            exclusively for the purpose of processing your online order.
                            Your data is only passed on here insofar as it is actually
                            necessary for processing the order.</p>
                        <p><b>9.5</b>&nbsp;Shopify Digital Download</p>
                        <p>For order fulfilment we use the following provider: Shopify
                            International Limited, Victoria Buildings, 2nd floor, 1-2
                            Haddington Road, Dublin 4, D04 XN32, Ireland</p>
                        <p>Name, address and, where applicable, further personal data is
                            passed on to the provider pursuant to Art. 6(1)(b) DSGVO (GDPR)
                            exclusively for the purpose of processing the online order.
                            Your data is only passed on here insofar as it is actually
                            necessary for processing the order.</p>
                        <p><b>9.6</b>&nbsp;Disclosure of personal data to shipping service
                            providers</p>
                        <p>- Deutsche Post</p>
                        <p>As a transport service provider, we use the following provider:
                            Deutsche Post AG, Charles-de-Gaulle-Stra&szlig;e 20,
                            53113 Bonn, Germany</p>
                        <p>We pass on your e-mail address and/or telephone number pursuant
                            to Art. 6(1)(a) DSGVO (GDPR) to the provider before delivery of
                            the goods for the purpose of coordinating a delivery date or for
                            delivery notification, provided that you have given your express
                            consent for this during the ordering process. Otherwise, for
                            the purpose of delivery, we pass on to the provider pursuant to
                            Art. 6(1)(b) DSGVO (GDPR) only the recipient's name and the
                            delivery address. The disclosure takes place only insofar as it
                            is necessary for the delivery of the goods. In this case, prior
                            coordination of the delivery date with the provider or delivery
                            notification is not possible.</p>
                        <p>Consent can be revoked at any time with effect for the future
                            vis-&agrave;-vis the controller named above or vis-&agrave;-vis
                            the provider.<br/>
                            - DHL</p>
                        <p>As a transport service provider, we use the following provider:
                            DHL Paket GmbH, Str&auml;&szlig;chensweg 10, 53113
                            Bonn, Germany</p>
                        <p>We pass on your e-mail address and/or telephone number pursuant
                            to Art. 6(1)(a) DSGVO (GDPR) to the provider before delivery of
                            the goods for the purpose of coordinating a delivery date or for
                            delivery notification, provided that you have given your express
                            consent for this during the ordering process. Otherwise, for
                            the purpose of delivery, we pass on to the provider pursuant to
                            Art. 6(1)(b) DSGVO (GDPR) only the recipient's name and the
                            delivery address. The disclosure takes place only insofar as it
                            is necessary for the delivery of the goods. In this case, prior
                            coordination of the delivery date with the provider or delivery
                            notification is not possible.</p>
                        <p>Consent can be revoked at any time with effect for the future
                            vis-&agrave;-vis the controller named above or vis-&agrave;-vis
                            the provider.</p>
                        <p><b>9.7</b>&nbsp;Use of payment service providers (payment
                            services)</p>
                        <p>- Paypal</p>
                        <p>On this website, one or more online payment methods of the
                            following provider are available: PayPal (Europe) S.a.r.l. et
                            Cie, S.C.A., 22-24 Boulevard Royal, L-2449 Luxembourg</p>
                        <p>If you select a payment method of the provider where you pay in
                            advance, the payment data you provide during the order process
                            (including name, address, bank and payment card information,
                            currency and transaction number) as well as information about
                            the content of your order is passed on to the provider pursuant
                            to Art. 6(1)(b) DSGVO (GDPR). In this case, your data is passed
                            on exclusively for the purpose of payment processing with the
                            provider and only insofar as it is necessary for this.</p>
                        <p>If you select a payment method where we pay in advance, you will
                            also be asked during the order process to provide certain
                            personal data (first and last name, street, house number,
                            postal code, city, date of birth, e-mail address, telephone
                            number, and where applicable data on an alternative means of
                            payment).</p>
                        <p>In such cases, in order to safeguard our legitimate interest in
                            establishing your ability to pay, this data is forwarded by us
                            pursuant to Art. 6(1)(f) DSGVO (GDPR) to the provider for the
                            purpose of a credit check. On the basis of the personal data you
                            have provided as well as further data (such as shopping cart,
                            invoice amount, order history, payment experience), the provider
                            checks whether the payment option you have selected can be
                            granted with regard to payment and/or default risks.</p>
                        <p>The credit report may contain probability values (so-called
                            score values). Insofar as score values are included in the
                            result of the credit report, they are based on a scientifically
                            recognized mathematical-statistical procedure. The calculation
                            of the score values includes, among other things but not
                            exclusively, address data.</p>
                        <p>You can object to this processing of your data at any time by a
                            message to us or vis-&agrave;-vis the provider. However, the
                            provider may, where applicable, remain entitled to process your
                            personal data insofar as this is necessary for contractual
                            payment processing.<br/>
                            - Stripe</p>
                        <p>On this website, one or more online payment methods of the
                            following provider are available: Stripe Payments Europe Ltd.,
                            1 Grand Canal Street Lower, Grand Canal Dock, Dublin, Ireland</p>
                        <p>If you select a payment method of the provider where you pay in
                            advance (for example credit card payment), the payment data you
                            provide during the order process (including name, address, bank
                            and payment card information, currency and transaction number)
                            as well as information about the content of your order is passed
                            on to the provider pursuant to Art. 6(1)(b) DSGVO (GDPR). In
                            this case, your data is passed on exclusively for the purpose of
                            payment processing with the provider and only insofar as it is
                            necessary for this.</p>
                        <p>If you select a payment method where the provider pays in
                            advance (for example purchase on account or in instalments or
                            direct debit), you will also be asked during the order process
                            to provide certain personal data (first and last name, street,
                            house number, postal code, city, date of birth, e-mail address,
                            telephone number, and where applicable data on an alternative
                            means of payment).</p>
                        <p>In order to safeguard our legitimate interest in establishing
                            the ability of our customers to pay, this data is forwarded by
                            us pursuant to Art. 6(1)(f) DSGVO (GDPR) to the provider for the
                            purpose of a credit check. On the basis of the personal data you
                            have provided as well as further data (such as shopping cart,
                            invoice amount, order history, payment experience), the provider
                            checks whether the payment option you have selected can be
                            granted with regard to payment and/or default risks.</p>
                        <p>The credit report may contain probability values (so-called
                            score values). Insofar as score values are included in the
                            result of the credit report, they are based on a scientifically
                            recognized mathematical-statistical procedure. The calculation
                            of the score values includes, among other things but not
                            exclusively, address data.</p>
                        <p>You can object to this processing of your data at any time by a
                            message to us or vis-&agrave;-vis the provider. However, the
                            provider may, where applicable, remain entitled to process your
                            personal data insofar as this is necessary for contractual
                            payment processing.</p>
                        <p><b>9.8</b>&nbsp;Electronic withdrawal function for distance
                            contracts</p>
                        <p>Consumers who conclude contracts on this website for which a
                            statutory right of withdrawal exists have the option of
                            declaring the withdrawal via an electronic withdrawal function
                            in accordance with the applicable withdrawal provisions.</p>
                        <p>When using the withdrawal function, in addition to details for
                            identifying the contract to be withdrawn, further personal
                            information such as the consumer's first and last name as well
                            as e-mail address must be provided or confirmed.</p>
                        <p>The collection of this information and its transmission to us is
                            carried out here pursuant to Art. 6(1)(b) DSGVO (GDPR) and only
                            insofar as it is necessary for the proper processing of the
                            withdrawal. Also on the basis of Art. 6(1)(b) DSGVO (GDPR), the
                            personal data provided is used to confirm receipt of the
                            declaration of withdrawal by e-mail. A further legal basis for
                            the processing is Art. 6(1)(c) DSGVO (GDPR). We are legally
                            obliged to provide an electronic withdrawal function for
                            paid consumer distance contracts.</p>
                        <h2>10) Site functionalities</h2>
                        <p><b>10.1</b>&nbsp;Facebook Connect</p>
                        <p>On our website we provide a single sign-on function of the
                            following provider: Meta Platforms Ireland Ltd., 4 Grand Canal
                            Square, Grand Canal Harbour, Dublin 2, Ireland.</p>
                        <p>In addition to a transmission of data to the above-mentioned
                            provider location, data may also be transmitted to: Meta
                            Platforms Inc., USA.</p>
                        <p>If you have an account with the provider, you can use these
                            account details to log in to create a user account or to
                            register on our website.</p>
                        <p>When you visit this site, this login function may establish a
                            direct connection between your browser and the provider's
                            servers, even if you do not have an account with the provider or
                            are not logged into one. The provider thereby receives the
                            information that you have visited our site. The information
                            collected in this respect (where applicable including your IP
                            address) is transmitted by your browser directly to a server of
                            the provider and stored there. The information is, however, not
                            used to identify you personally and is not passed on to third
                            parties.</p>
                        <p>These data processing operations are carried out pursuant to
                            Art. 6(1)(f) DSGVO (GDPR) on the basis of our legitimate
                            interest in a user-friendly and interactive design of our online
                            presence.</p>
                        <p>If you click the login button to register on our website with
                            the data of your account with the provider, the provider
                            transmits to us, exclusively on the basis of your express
                            consent pursuant to Art. 6(1)(a) DSGVO (GDPR), the general and
                            publicly accessible information stored in your account (user ID,
                            name, address, e-mail address, age and gender).</p>
                        <p>We store and use the data transmitted by the provider to set up
                            a user account with the necessary data (salutation, first name,
                            last name, address data, country, e-mail address, date of
                            birth), provided that you have released this to the provider.
                            Conversely, on the basis of your consent, data (e.g.
                            information about your browsing or purchasing behaviour) may be
                            transferred by us to your account with the provider.</p>
                        <p>The consent given can be revoked at any time with effect for the
                            future vis-&agrave;-vis us.</p>
                        <p>For data transfers to the USA, the provider has joined the
                            EU-US Data Privacy Framework, which, on the basis of an
                            adequacy decision of the European Commission, ensures
                            compliance with the European level of data protection.</p>
                        <p><b>10.2</b>&nbsp;Google Sign-In</p>
                        <p>On our website we provide a single sign-on function of the
                            following provider: Google Ireland Limited, Gordon House, 4
                            Barrow St, Dublin, D04 E5W5, Ireland.</p>
                        <p>In addition to a transmission of data to the above-mentioned
                            provider location, data may also be transmitted to: Google LLC,
                            USA.</p>
                        <p>If you have an account with the provider, you can use these
                            account details to log in to create a user account or to
                            register on our website.</p>
                        <p>When you visit this site, this login function may establish a
                            direct connection between your browser and the provider's
                            servers, even if you do not have an account with the provider or
                            are not logged into one. The provider thereby receives the
                            information that you have visited our site. The information
                            collected in this respect (where applicable including your IP
                            address) is transmitted by your browser directly to a server of
                            the provider and stored there. The information is, however, not
                            used to identify you personally and is not passed on to third
                            parties.</p>
                        <p>These data processing operations are carried out pursuant to
                            Art. 6(1)(f) DSGVO (GDPR) on the basis of our legitimate
                            interest in a user-friendly and interactive design of our online
                            presence.</p>
                        <p>If you click the login button to register on our website with
                            the data of your account with the provider, the provider
                            transmits to us, exclusively on the basis of your express
                            consent pursuant to Art. 6(1)(a) DSGVO (GDPR), the general and
                            publicly accessible information stored in your account (user ID,
                            name, address, e-mail address, age and gender).</p>
                        <p>We store and use the data transmitted by the provider to set up
                            a user account with the necessary data (salutation, first name,
                            last name, address data, country, e-mail address, date of
                            birth), provided that you have released this to the provider.
                            Conversely, on the basis of your consent, data (e.g.
                            information about your browsing or purchasing behaviour) may be
                            transferred by us to your account with the provider.</p>
                        <p>The consent given can be revoked at any time with effect for the
                            future vis-&agrave;-vis us.</p>
                        <p>For data transfers to the USA, the provider has joined the
                            EU-US Data Privacy Framework, which, on the basis of an
                            adequacy decision of the European Commission, ensures
                            compliance with the European level of data protection.</p>
                        <p>You can find further information on Google's data protection
                            here: <a
                                href="https://business.safety.google/intl/de/privacy/"
                                target="_blank">https://business.safety.google
                                <wbr/>
                                /intl
                                <wbr/>
                                /de
                                <wbr/>
                                /privacy
                                <wbr/>
                                /</a></p>
                        <p><b>10.3</b>&nbsp;OpenStreetMap</p>
                        <p>This website uses an online map service of the following
                            provider: OpenStreetMap Foundation, St John&rsquo;s
                            Innovation Centre, Cowley Road, Cambridge, CB4 0WS, UK</p>
                        <p>The online map service is a tool for displaying interactive
                            maps in order to present geographical information visually.
                            Through the use of this service, our location is shown to you
                            and any geolocation is facilitated.</p>
                        <p>Already when you call up those subpages in which the provider's
                            map is embedded, information about your use of our website (such
                            as your IP address) is transferred to the provider's servers
                            and stored there.</p>
                        <p>The processing of your personal data is carried out pursuant to
                            Art. 6(1)(f) DSGVO (GDPR) on the basis of our legitimate
                            interest in the needs-based design of our website. If you do
                            not agree with the future transmission of your data to the
                            provider, there is the option of completely deactivating the
                            provider's online map service by switching off the JavaScript
                            application in your browser. The online map service on this
                            website can then no longer be used.</p>
                        <p>Insofar as legally required, we have obtained your consent for
                            the processing of your data as described above pursuant to Art.
                            6(1)(a) DSGVO (GDPR). You can revoke the consent you have given
                            at any time with effect for the future. To exercise your
                            withdrawal, please follow the option for raising an objection
                            described above.</p>
                        <p>For a data transfer to the provider location, an adequate level
                            of data protection is ensured by an adequacy decision of the
                            European Commission.</p>
                        <p><b>10.4</b>&nbsp;- Friendly Captcha</p>
                        <p>On this website we use the CAPTCHA service of the following
                            provider: Friendly Captcha GmbH, Am Anger 3-5,
                            82237 W&ouml;rthsee</p>
                        <p>The service checks whether an entry is made by a natural person
                            or abusively by mechanical and automated processing, and blocks
                            spam, DDoS attacks and similar automated malicious access.</p>
                        <p>When you call up a page of our website that contains the
                            provider's captcha elements, your browser establishes a direct
                            connection to the provider's servers in order to load the
                            elements properly. In doing so, certain browser information,
                            including your IP address, is transmitted to the provider.</p>
                        <p>The legal basis is our legitimate interest in establishing
                            individual personal responsibility on the internet and in
                            avoiding misuse and spam pursuant to Art. 6(1)(f) DSGVO
                            (GDPR).</p>
                        <p>Following the transmission, the collected browser information is
                            automatically and immediately anonymized, so that no personal
                            data is processed for the verification of the human origin of a
                            page interaction.</p>
                        <p>We have concluded a data processing agreement with the provider
                            that ensures the protection of our site visitors' data and
                            prohibits unauthorized disclosure to third parties.</p>
                        <h2>11) Tools and miscellaneous</h2>
                        <p><b>11.1</b>&nbsp;Billbee</p>
                        <p>To handle your accounting, we use the cloud-based accounting
                            software service of the following provider: Billbee GmbH,
                            Arolser Str. 10, 34477 Twistetal, Germany.</p>
                        <p>The provider processes incoming and outgoing invoices as well as,
                            where applicable, the bank transactions of our company, in order
                            to automatically record invoices, match them to transactions and,
                            from this, prepare the financial accounting in a partially
                            automated process.</p>
                        <p>Insofar as personal data is also processed in the process, the
                            processing is carried out on the basis of our legitimate
                            interest in the efficient organization and documentation of our
                            business transactions.</p>
                        <p><b>11.2</b>&nbsp;BuchhaltungsButler</p>
                        <p>To handle your accounting, we use the cloud-based accounting
                            software service of the following provider: BuchhaltungsButler
                            GmbH, Ausbau 1, 15910 Unterspreewald, Germany</p>
                        <p>The provider processes incoming and outgoing invoices as well as,
                            where applicable, the bank transactions of our company, in order
                            to automatically record invoices, match them to transactions and,
                            from this, prepare the financial accounting in a partially
                            automated process.</p>
                        <p>Insofar as personal data is also processed in the process, the
                            processing is carried out on the basis of our legitimate
                            interest in the efficient organization and documentation of our
                            business transactions.</p>
                        <p><b>11.3</b>&nbsp;Cookie consent tool</p>
                        <p>To obtain effective user consent for cookies requiring consent
                            and cookie-based applications, this website uses a so-called
                            &bdquo;cookie consent tool&#8220;. The
                            &bdquo;cookie consent tool&#8220; is displayed to you when you
                            access the site in the form of an interactive user interface on
                            which you can grant consent for certain cookies and/or
                            cookie-based applications by ticking boxes. By using the tool,
                            all cookies/services requiring consent are loaded only if you
                            grant the corresponding consents by ticking boxes. This ensures
                            that such cookies are set on your respective device only in the
                            case of consent given.</p>
                        <p>The tool sets technically necessary cookies in order to store
                            your cookie preferences. As a rule, personal user data is not
                            processed in the process.</p>
                        <p>If, in individual cases, personal data (such as the IP address)
                            is nevertheless processed for the purpose of storing, assigning
                            or logging cookie settings, this is carried out pursuant to Art.
                            6(1)(f) DSGVO (GDPR) on the basis of our legitimate interest in
                            legally compliant, user-specific and user-friendly consent
                            management for cookies and thus in a legally compliant design of
                            our online presence.</p>
                        <p>A further legal basis for the processing is also Art. 6(1)(c)
                            DSGVO (GDPR). As controllers, we are subject to the legal
                            obligation to make the use of technically non-necessary cookies
                            dependent on the respective user consent.</p>
                        <p>Insofar as necessary, we have concluded a data processing
                            agreement with the provider that ensures the protection of our
                            site visitors' data and prohibits unauthorized disclosure to
                            third parties.</p>
                        <p>You can find further information on the operator and the
                            settings options of the cookie consent tool directly in the
                            corresponding user interface on our website.</p>
                        <h2>12) Rights of the data subject</h2>
                        <p><b>12.1</b>&nbsp;Applicable data protection law grants you, with
                            regard to the processing of your personal data, the following
                            data subject rights (rights to information and intervention)
                            vis-&agrave;-vis us as the controller, whereby reference is made
                            to the cited legal basis for the respective conditions for
                            exercising them:</p>
                        <ul>
                            <li>Right of access pursuant to Art. 15 DSGVO (GDPR);</li>
                            <li>Right to rectification pursuant to Art. 16 DSGVO (GDPR);
                            </li>
                            <li>Right to erasure pursuant to Art. 17 DSGVO (GDPR);
                            </li>
                            <li>Right to restriction of processing pursuant to Art. 18
                                DSGVO (GDPR);
                            </li>
                            <li>Right to be informed pursuant to Art. 19 DSGVO (GDPR);
                            </li>
                            <li>Right to data portability pursuant to Art. 20 DSGVO (GDPR);
                            </li>
                            <li>Right to withdraw consent given pursuant to Art. 7(3) DSGVO
                                (GDPR);
                            </li>
                            <li>Right to lodge a complaint pursuant to Art. 77 DSGVO (GDPR).</li>
                        </ul>
                        <p><b>12.2</b>&nbsp;RIGHT TO OBJECT</p>
                        <p>IF, WITHIN THE SCOPE OF A BALANCING OF INTERESTS, WE PROCESS
                            YOUR PERSONAL DATA ON THE BASIS OF OUR OVERRIDING LEGITIMATE
                            INTEREST, YOU HAVE THE RIGHT AT ANY TIME, ON GROUNDS RELATING TO
                            YOUR PARTICULAR SITUATION, TO OBJECT TO THIS PROCESSING WITH
                            EFFECT FOR THE FUTURE.</p>
                        <p>IF YOU EXERCISE YOUR RIGHT TO OBJECT, WE WILL END THE PROCESSING
                            OF THE DATA CONCERNED. HOWEVER, FURTHER PROCESSING REMAINS
                            RESERVED IF WE CAN DEMONSTRATE COMPELLING LEGITIMATE GROUNDS FOR
                            THE PROCESSING WHICH OVERRIDE YOUR INTERESTS, FUNDAMENTAL RIGHTS
                            AND FREEDOMS, OR IF THE PROCESSING SERVES THE ESTABLISHMENT,
                            EXERCISE OR DEFENCE OF LEGAL CLAIMS.</p>
                        <p>IF YOUR PERSONAL DATA IS PROCESSED BY US FOR THE PURPOSE OF
                            DIRECT ADVERTISING, YOU HAVE THE RIGHT TO OBJECT AT ANY TIME TO
                            THE PROCESSING OF PERSONAL DATA CONCERNING YOU FOR THE PURPOSE
                            OF SUCH ADVERTISING. YOU CAN EXERCISE THE OBJECTION AS DESCRIBED
                            ABOVE.</p>
                        <p>IF YOU EXERCISE YOUR RIGHT TO OBJECT, WE WILL END THE PROCESSING
                            OF THE DATA CONCERNED FOR DIRECT ADVERTISING PURPOSES.</p>
                        <h2>13) Duration of the storage of personal data</h2>
                        <p>The duration of the storage of personal data is determined on
                            the basis of the respective legal basis, the purpose of
                            processing and &ndash; where applicable &ndash; additionally on
                            the basis of the respective statutory retention period (e.g.
                            retention periods under commercial and tax law).</p>
                        <p>When personal data is processed on the basis of express consent
                            pursuant to Art. 6(1)(a) DSGVO (GDPR), the data concerned is
                            stored until you revoke your consent.</p>
                        <p>If statutory retention periods exist for data that is processed
                            within the framework of legal or quasi-legal obligations on the
                            basis of Art. 6(1)(b) DSGVO (GDPR), this data is routinely
                            deleted after expiry of the retention periods, provided that it
                            is no longer required for the performance or initiation of the
                            contract and/or we have no remaining legitimate interest in
                            continued storage.</p>
                        <p>When personal data is processed on the basis of Art. 6(1)(f)
                            DSGVO (GDPR), this data is stored until you exercise your right
                            to object under Art. 21(1) DSGVO (GDPR), unless we can
                            demonstrate compelling legitimate grounds for the processing
                            which override your interests, rights and freedoms, or the
                            processing serves the establishment, exercise or defence of
                            legal claims.</p>
                        <p>When personal data is processed for the purpose of direct
                            advertising on the basis of Art. 6(1)(f) DSGVO (GDPR), this
                            data is stored until you exercise your right to object under
                            Art. 21(2) DSGVO (GDPR).</p>
                        <p>Unless otherwise stated in the other information in this
                            statement on specific processing situations, stored personal
                            data is otherwise deleted when it is no longer necessary for the
                            purposes for which it was collected or otherwise processed.</p></div>
                </ContentWrapper>
            </article>
        </React.Fragment>
    );
};

export default Privacy;



// WEBPACK FOOTER //
// ./src/components/en/Privacy.js